// source: messages/enums/payload_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

goog.exportSymbol("proto.PayloadType", null, global);
/**
 * @enum {number}
 */
proto.PayloadType = {
  MESSAGE: 0,
  PROGRESS: 1,
  TASK_RESULT: 2,
};

goog.object.extend(exports, proto);
